module.exports = __webpack_public_path__ + "static/img/Crane_Logo_white.6d822315.png";